<template>
  <div>
      <b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" />

      <div class="columns">
        <div class="column is-8">
<b-message has-icon type="is-info" size="is-small">Look, just because I don't be givin' no man a foot massage don't make it right for Marsellus to throw Antwone into a glass motherfuckin' house, fuckin' up the way the nigger talks. </b-message>
        </div>
        <div class="column is-4">
          <b-pagination :total="total" :current.sync="currentPage" order="is-right" :rounded="true" :simple="true" :per-page="perPage" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
          </b-pagination>
        </div>

      </div>

        <b-table :data="products" :columns="columns" :striped="true">

              <!-- <template slot-scope="props">
                  <b-table-column field="id" label="ID" width="40" sortable numeric>
                      {{ props.row.id }}
                  </b-table-column>

                  <b-table-column field="user.first_name" label="First Name" sortable>
                      {{ props.row.user.first_name }}
                  </b-table-column>

                  <b-table-column field="user.last_name" label="Last Name" sortable>
                      {{ props.row.user.last_name }}
                  </b-table-column>

                  <b-table-column field="date" label="Date" sortable centered>
                      <span class="tag is-success">
                          {{ new Date(props.row.date).toLocaleDateString() }}
                      </span>
                  </b-table-column>

                  <b-table-column label="Gender">
                      <b-icon pack="fas"
                          :icon="props.row.gender === 'Male' ? 'mars' : 'venus'">
                      </b-icon>
                      {{ props.row.gender }}
                  </b-table-column>
              </template> -->
          </b-table>

  </div>
</template>

<script>

export default {
  name: "productsTable",
  props: ["category",],
  components: {
  },
  data() {
      return {
          isLoading: true,
          activeOrdering: "-meta_chunks_total_count",
          //sort: "desc",
          perPage: 10,
          total: null,
          currentPage: 1,
          products: [],
          columns: [
                  {
                      field: 'name',
                      label: 'Name',
                  },
                  {
                      field: 'vendor.name',
                      label: 'Vendor',
                  },
                  {
                      field: "meta_chunks_total_count",
                      label: '# Feedbacks',
                  },
                  // {
                  //     field: 'date',
                  //     label: 'Date',
                  //     centered: true
                  // },
                  // {
                  //     field: 'gender',
                  //     label: 'Gender',
                  // }
              ]
      }
  },
  methods: {
    getProducts: function() {
        this.isLoading = true

        // Fixes bug with page 0
        if (this.currentPage == 0) {
            this.currentPage = 1
        }

        this.url = `${this.$root.api_base_url}products/?page=${this.currentPage}&ordering=${this.activeOrdering}`

        if (this.search) {
            this.url = `&search=${this.search}`
        }

        if (this.category) {
          this.url += `&categories=${this.category.id}`
        }

        this.$http.get(this.url)
            .then(({
                data
            }) => {
                this.products = []
                data.results.forEach((item) => this.products.push(item))
                this.total = data.count
            })
            .catch((error) => {
                this.data = []
                this.$snackbar.open({
                    message: error,
                    type: "is-warning"
                })
                throw error
            })
            .finally(() => {
                this.isLoading = false
            })
    },
  },
  watch: {
      // activeOrdering: function() {
      //     this.currentPage = 1
      //     this.getCategories()
      // },
      currentPage: function() {
          this.getProducts()
      },
      // search: debounce(function() {
      //     this.currentPage = 1
      //     this.getCategories()
      // }, 500),
  },
  mounted: function() {
      this.getProducts()
  }
}

</script>

<style scoped>

</style>
